import { postJSON, post, get } from '@/utils/axios'

// 门店可用iot施工项目列表
export const getSelectStoreIotProjectList = () => postJSON('iotProject/selectStoreIotProjectList')

// 门店未合作的iot施工项目列表
export const getSelectUnCooperationIotProjectList = () => postJSON('iotProject/selectUnCooperationIotProjectList')

// 百万盈利里面的施工案例
interface selectCaseListProps {
    page?: string | number //当前页
    size?: string | number //每页大小
    cloudServicePk?: string //云服务pk
}
export const getSelectCaseList = (options:selectCaseListProps) => postJSON(`case/selectCaseList`, options)

// 获取产值排名
interface getOutputValueRankingProps {
    createStartTime?: string //创建开始时间 年月日
    page?: string | number //当前页
    createEndTime?: string //开始结束时间 年月日
    size?: string | number //每页大小
    orgType?: string //0-商户排名 1-下属门店 2-全国门店
    cloudServicesName?: string //项目名称
}
export const getOutputValueRanking = (options:getOutputValueRankingProps) => postJSON(`/yme-agency/outputValue/getOutputValueRanking`, options)

//获取案例全部-项目
export const getCaseAllProject = () => postJSON(`/yme-agency/caseRanking/getCaseAllProject`)

//我的门店产值排名
interface myOrgIotProjectOutputValueRankProps {
    page?: string | number //当前页
    iotProjectPk?: string //iot项目pk
    size?: string | number //每页大小
    startTime?: string //开始日期
    endTime?: string //截止日期
}
export const getMyOrgIotProjectOutputValueRank = (options:myOrgIotProjectOutputValueRankProps) => postJSON(`iotProject/myOrgIotProjectOutputValueRank`, options)

//门店产值排名
export const getOrgIotProjectOutputValueRank = (options:myOrgIotProjectOutputValueRankProps) => postJSON(`iotProject/orgIotProjectOutputValueRank`, options)

//获取全部IOT项目
export const getAllIotProject = () => get(`/yme-agency/projectBase/getAllIotProject`)

/**
 * 数据驾驶舱
 */
interface createBillStatistics {
    page?: string | number //当前页
    size?: string | number //每页大小
    startTime?: string //开始日期
    endTime?: string //截止日期
}
//财务-统计
export const getFinanceStatistics = (options) => postJSON(`dataCockpit/financeStatistics`, options)

//财务-总毛利/总产值/排名统计
export const getFinanceGrossProfitStatistics = (options:createBillStatistics) => postJSON(`dataCockpit/financeGrossProfitStatistics`, options)

//财务-总毛利排名
export const getGrossProfitRank = (options:createBillStatistics) => postJSON(`dataCockpit/grossProfitRank`, options)

//财务-本店总毛利排名
export const getOrgGrossProfitRank = (options:createBillStatistics) => postJSON(`dataCockpit/orgGrossProfitRank`, options)

//财务-总产值排名
export const getOutputValueRank = (options:createBillStatistics) => postJSON(`dataCockpit/outputValueRank`, options)

//财务-本店总产值排名
export const getOrgOutputValueRank = (options:createBillStatistics) => postJSON(`dataCockpit/orgOutputValueRank`, options)

//开单-统计
export const getCreateBillStatistics = (options:createBillStatistics) => postJSON(`dataCockpit/createBillStatistics`, options)

//施工-统计
export const getConstructionStatistics = (options:createBillStatistics) => postJSON(`dataCockpit/constructionStatistics`, options)

//施工-技师施工排名
export const getTechnicianConstructionRank = (options:createBillStatistics) => postJSON(`dataCockpit/technicianConstructionRank`, options)

//案例-统计
export const getCaseStatistics = (options:createBillStatistics) => postJSON(`dataCockpit/caseStatistics`, options)

//案例-技师案例奖励排名
export const getTechnicianCaseRank = (options:createBillStatistics) => postJSON(`dataCockpit/technicianCaseRank`, options)

//报告-统计
export const getCheckReportStatistics = (options:createBillStatistics) => postJSON(`dataCockpit/checkReportStatistics`, options)

//保存门店pk赛海报图
export const setUpdatePkBannerImg = (pkBannerImg:string) => post(`org/updatePkBannerImg`, { pkBannerImg })

//查询门店pk赛海报图
export const getSelectOrgPkBannerImg = () => post(`org/selectOrgPkBannerImg`)

